import io from 'socket.io-client';

const sockets = io(
  process.env.REACT_APP_IO_ADDRESS || 'http://localhost:8000',
  {
    autoConnect: true,
    forceNew: false,
    multiplex: false,
  }
);
// const sockets = io('/');
export default sockets;
